<template>
  <section class="link-list" v-if="$props.links.length > 0">
    <h2>{{ $props.title }}</h2>
    <p>{{ $props.sub }}</p>
    <ul>
      <li v-for="link in $props.links">
        <a :href="link.path">
          <svg class="ph" v-if="$props.icon">
            <use :xlink:href="getIconKey(link.path)"></use>
          </svg>
          {{ link.link_text }}
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data: function () {
    return {}
  },
  methods: {
    getIconKey(path) {
      let linksArray = ["baby-friendly", "bank-holiday", "beach", "big", "child-friendly", "christmas", "coastal", "country", "dog-friendly", "easter", "family", "garden", "group-accommodation", "half-term", "hot-tub", "luxury", "new-year", "open-fire", "pet-friendly", "romantic", "romantic-cabins", "swimming-pool", "two-bedroom", "wifi", "large", "school-holiday", "sleeps12", "staycation", "summer-holiday", "two-bedroom"];
      let iconKey = "#icon-default-cottage";
      let pathKey = path.split('/')[path.split('/').length - 1];

      if (linksArray.includes(pathKey)){
        iconKey = "#icon-"+pathKey
      }

      return iconKey
    }
  },
  props: {
    links: Array,
    title: String,
    sub: String,
    icon: Boolean,
  },
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.link-list {
  padding: 1.25rem;
  margin: auto;

  p {
    margin: .25rem 0 0 0;
  }

  ul {
    list-style: none;
    padding: 1rem 0;
  }

  li {
    cursor: pointer;
    transition: 0.3s;
    display: inline-block;
    text-decoration: none;
    text-align: center;
    border: .0625rem solid $col_orange;
    border-radius: .3125rem;
    margin: 0 .325rem .325rem 0;

    a {
      padding: .75rem;
      text-decoration: none;
      color: $col_orange;
      font-size: .875rem;
      font-weight: 700;
      display: block;

      svg {
        margin-bottom: -0.25rem;
        margin-right: 0.25rem;
        height: 1.25rem;
        width: 1.25rem;
        filter: invert(43%) sepia(94%) saturate(1359%) hue-rotate(338deg) brightness(96%) contrast(105%);      }
    }

    &:hover,
    &:focus-within {
      background: $col_orange;
      text-decoration: none;

      a {
        color: $col_white;

        svg {
          filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(3deg) brightness(102%) contrast(102%);
        }
      }
    }
  }
}

@media #{$desktop} {
  .link-list {
    li a {
      padding: 1rem;
    }
  }
}

</style>